import Layout from "@/components/layout/Layout";
import PageHero from "@/components/shared/PageHero";
import SEOHead from "@/components/seo/SEOHead";
import SchemaMarkup from "@/components/seo/SchemaMarkup";

const Terms = () => {
  return (
    <Layout>
      <SEOHead
        title="Terms &amp; Conditions | Web Host Buy BD Service Agreement"
        description="Read Web Host Buy BD's Terms &amp; Conditions for BDIX hosting services. Service agreement, acceptable use policy, payment terms, refund policy &amp; SLA guarantees for all hosting services in Bangladesh."
        canonical="/terms-conditions"
        keywords="Web Host Buy BD, bdix hosting, web hosting Bangladesh"
      />
      <SchemaMarkup
        type="page"
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Terms &amp; Conditions", url: "/terms-conditions" },
        ]}
        pageName="Terms and Conditions - Web Host Buy BD"
        pageDescription="Web Host Buy BD's terms of service and conditions for BDIX hosting services"
      />
      <PageHero
        title="Terms &amp; Conditions"
        subtitle="Last updated: January 1, 2026"
      />

      <section className="py-20 bg-background">
        <div className="container-custom max-w-4xl">
          <article className="prose prose-lg max-w-none">
            <div className="space-y-8 text-foreground">
              <section>
                <h2 className="text-2xl font-bold mb-4">1. Acceptance of Terms</h2>
                <p className="text-muted-foreground leading-relaxed">
                  By accessing or using Web Host Buy BD's BDIX hosting services, you agree to be bound by these 
                  Terms and Conditions. If you do not agree to these terms, please do not use our services.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">2. Services</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Web Host Buy BD provides BDIX web hosting, domain registration, VPS, dedicated servers, 
                  and related services in Bangladesh. We reserve the right to modify, suspend, or discontinue any 
                  service at any time with reasonable notice.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">3. Account Responsibilities</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  You are responsible for:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Maintaining the confidentiality of your account credentials</li>
                  <li>All activities that occur under your account</li>
                  <li>Ensuring your contact information is accurate and up-to-date</li>
                  <li>Complying with all applicable laws and regulations in Bangladesh</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">4. Acceptable Use Policy</h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  You agree not to use our BDIX hosting services for:
                </p>
                <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                  <li>Illegal activities or content</li>
                  <li>Spam, phishing, or malware distribution</li>
                  <li>Copyright infringement</li>
                  <li>Harassment or abuse</li>
                  <li>Resource abuse that affects other users</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">5. Payment Terms</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Payment is due at the time of purchase or renewal. All hosting prices are in Bangladeshi 
                  Taka (BDT) unless otherwise specified. We accept various payment methods including 
                  bKash, Nagad, bank transfer, and credit/debit cards.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">6. Refund Policy</h2>
                <p className="text-muted-foreground leading-relaxed">
                  We offer a 30-day money-back guarantee on shared BDIX hosting plans. VPS, dedicated 
                  servers, and domain registrations are non-refundable. Refund requests must be 
                  submitted through our support system.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">7. Service Level Agreement</h2>
                <p className="text-muted-foreground leading-relaxed">
                  We guarantee 99.99% uptime for our BDIX hosting services. If we fail to meet this 
                  guarantee, you may be eligible for service credits as outlined in our SLA documentation.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">8. Limitation of Liability</h2>
                <p className="text-muted-foreground leading-relaxed">
                  Web Host Buy BD shall not be liable for any indirect, incidental, special, 
                  consequential, or punitive damages resulting from your use of our BDIX hosting services. 
                  Our total liability shall not exceed the amount paid for the service in question.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">9. Changes to Terms</h2>
                <p className="text-muted-foreground leading-relaxed">
                  We reserve the right to modify these terms at any time. We will notify users of 
                  significant changes via email or through our website. Continued use of our services 
                  after changes constitutes acceptance of the modified terms.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4">10. Contact Information</h2>
                <p className="text-muted-foreground leading-relaxed">
                  For questions about these Terms and Conditions, please contact Web Host Buy BD at:
                  <br /><br />
                  <strong>Email:</strong> hello@webhostbuybd.com<br />
                  <strong>Phone:</strong> +880 9649 660000<br />
                  <strong>Address:</strong> 10 Nur Vobon (2nd Floor), Nogor Vobon Road, Manikganj
                </p>
              </section>
            </div>
          </article>
        </div>
      </section>
    </Layout>
  );
};

export default Terms;